var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Formio } from 'formiojs';
import editFormDisplay from './editForm/DynamicPaymentMethods.edit.display';
import editFormData from './editForm/DynamicPaymentMethods.edit.data';
import editFormApi from './editForm/DynamicPaymentMethods.edit.api';
import editFormConditional from './editForm/DynamicPaymentMethods.edit.conditional';
import editFormLayout from './editForm/DynamicPaymentMethods.edit.layout';
var Components = Formio.Components;
var FieldComponent = Components.components.field;
/**
 * DynamicPaymentMethods class extending from a formio field base component.
 *
 * @author Peter Boersma <@Lycan_gray>
 * @author Robert Moelker <@robertmoelker>
 *
 * @copyright Novti - 2024
 */
var DynamicPaymentMethods = /** @class */ (function (_super) {
    __extends(DynamicPaymentMethods, _super);
    function DynamicPaymentMethods() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DynamicPaymentMethods.prototype.init = function () {
        var _a, _b, _c, _d;
        window._novti_dpm_initialLoad = true;
        this.frequency = (_d = (_c = (_b = (_a = this.root) === null || _a === void 0 ? void 0 : _a.getComponent('frequencyamounts')) === null || _b === void 0 ? void 0 : _b.component) === null || _c === void 0 ? void 0 : _c.default_frequency) !== null && _d !== void 0 ? _d : 'once';
        _super.prototype.init.call(this);
    };
    DynamicPaymentMethods.schema = function () {
        var extend = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            extend[_i] = arguments[_i];
        }
        return FieldComponent.schema.apply(FieldComponent, __spreadArrays([{
                type: 'dynamicpaymentmethods',
                label: 'Dynamic Payment Methods',
                key: 'dynamicPaymentMethods',
            }], extend));
    };
    Object.defineProperty(DynamicPaymentMethods, "builderInfo", {
        get: function () {
            return {
                title: 'Dynamic Payment methods',
                icon: 'terminal',
                group: 'basic',
                documentation: '/userguide/#field',
                weight: 0,
                schema: DynamicPaymentMethods.schema()
            };
        },
        enumerable: false,
        configurable: true
    });
    DynamicPaymentMethods.prototype.render = function (children) {
        return _super.prototype.render.call(this, this.renderTemplate('dynamicpaymentmethods', {
            enabledPaymentMethods: this.enabledPaymentMethods,
            currentPaymentMethod: this.getValue()
        }));
    };
    Object.defineProperty(DynamicPaymentMethods.prototype, "enabledPaymentMethods", {
        /**
         * Getter for the enabled payment methods depending on frequency.
         */
        get: function () {
            var _this = this;
            var _a, _b, _c;
            if (!this.component.available_payment_methods_list
                || Object.keys(this.component.available_payment_methods_list).length === 0) {
                return null;
            }
            if (this.data.frequencyamounts && this.data.frequencyamounts.frequency) {
                this.frequency = this.data.frequencyamounts.frequency;
            }
            if (window._novti_dpm_initialFrequency) {
                if (((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.frequencyamounts) === null || _b === void 0 ? void 0 : _b.frequency) !== window._novti_dpm_initialFrequency) {
                    window._novti_dpm_initialLoad = true;
                    window._novti_dpm_initialFrequency = (_c = this.data.frequencyamounts) === null || _c === void 0 ? void 0 : _c.frequency;
                }
            }
            return this.component.available_payment_methods_list
                .filter(function (method) {
                return method.enabled !== false
                    && (method.frequencies || ['once']).includes(_this.frequency);
            })
                .map(function (method) {
                var _a, _b;
                var key = _this.transformMethodKey(method.name);
                var defaultPaymentMethod = (_b = (_a = _this.data) === null || _a === void 0 ? void 0 : _a.dynamicpaymentmethods) === null || _b === void 0 ? void 0 : _b.paymentmethod;
                if (window._novti_dpm_initialLoad || defaultPaymentMethod === undefined) {
                    defaultPaymentMethod = _this.component["default_payment_method_" + _this.frequency];
                }
                return __assign(__assign({}, method), { id: Date.now(), key: key, default: (_this.transformMethodKey(defaultPaymentMethod) === key) });
            });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Event Handler to update the value of the component.
     *
     * @param {Event} event
     * @param {string} key
     *
     * @return {void}
     */
    DynamicPaymentMethods.prototype.eventHandler = function (event, key) {
        var _a;
        var _b, _c, _d, _e;
        var _f = event.target, value = _f.value, dataset = _f.dataset, parentElement = _f.parentElement;
        // Add the modified state to the input for FormIO input compliance.
        if (parentElement.getAttribute('ref') === 'component'
            && parentElement.classList.contains('formio-component')) {
            if (value.length > 0) {
                parentElement.classList.add('formio-modified');
            }
            else {
                parentElement.classList.remove('formio-modified');
            }
        }
        if (key === 'paymentmethod' && (((_b = this.getValue()) === null || _b === void 0 ? void 0 : _b.paymentmethod) !== (dataset === null || dataset === void 0 ? void 0 : dataset.value))) {
            this.resetHTMLElements(Object.keys((_c = this.getValue()) !== null && _c !== void 0 ? _c : {}));
            this.updateValue({});
        }
        // Define the flag event so it doesn't bother error message on load
        var flags = (event instanceof CustomEvent && ((_d = event === null || event === void 0 ? void 0 : event.detail) === null || _d === void 0 ? void 0 : _d.initial)) ? {} : { modified: true };
        var updateValues = __assign(__assign({}, this.getValue()), (_a = {}, _a[key] = (_e = dataset.value) !== null && _e !== void 0 ? _e : value, _a));
        // If the keys are predefined make sure to add the required formio-modified
        // this happens either via a redraw or possible via prefill data
        Object.keys(updateValues).forEach(function (key) {
            var elem = document.querySelector("[name=\"data[" + key + "]\"]");
            if (elem) {
                elem.parentElement.classList.add('formio-modified');
            }
        });
        this.updateValue(updateValues, flags);
    };
    /**
     * Resets the elements to a empty state
     * causing the DOM to be identical with the data.
     *
     * @param {string[]} elements
     *
     * @returns {void}
     */
    DynamicPaymentMethods.prototype.resetHTMLElements = function (elements) {
        elements.filter(function (element) { return element !== 'paymentmethod'; }).forEach(function (element) {
            var elem = document.querySelector("[name=\"data[" + element + "]");
            if (elem instanceof HTMLInputElement) {
                if (elem.type === 'radio' || elem.type === 'checkbox') {
                    elem.checked = false;
                }
                else {
                    elem.value = '';
                }
            }
            if (elem.parentElement.classList.contains('formio-modified')) {
                elem.parentElement.classList.remove('formio-modified');
            }
            if (elem instanceof HTMLSelectElement) {
                elem.selectedIndex = 0;
            }
        });
    };
    /**
     * Transforms the given value to a lowercase alpha-numeric representation.
     *
     * @param {string} name
     *
     * @returns {string}
     */
    DynamicPaymentMethods.prototype.transformMethodKey = function (name) {
        return name.toLowerCase().replace(' ', '');
    };
    /**
     * After the html string has been mounted into the dom, the dom element is returned here.
     * Use refs to find specific elements to attach functionality to.
     *
     * @param {Element} element
     *
     * @returns {Promise}
     */
    DynamicPaymentMethods.prototype.attach = function (element) {
        var _this = this;
        if (!this.enabledPaymentMethods) {
            return _super.prototype.attach.call(this, element);
        }
        var refs = {
            'paymentmethod': 'multiple'
        };
        // Set the refs depending on the available / enabled paymentmethods.
        this.enabledPaymentMethods.forEach(function (method) {
            if (method.optionsName) {
                refs[method.optionsName] = method.displayType === 'select' ? 'single' : 'multiple';
            }
            if (method.multiField) {
                method.multiField.forEach(function (field) {
                    refs[field.name] = 'single';
                });
            }
        });
        if (this.root.getComponent('frequencyamounts')) {
            if (this.data.frequencyamounts && window._novti_dpm_initialFrequency !== this.data.frequencyamounts.frequency) {
                window._novti_dpm_initialLoad = true;
            }
        }
        this.loadRefs(element, refs);
        var _loop_1 = function (key, reference) {
            if (reference instanceof NodeList) {
                reference.forEach(function (element) {
                    var _a, _b;
                    element.addEventListener('change', function (event) {
                        _this.eventHandler(event, key);
                    });
                    // Initialize the payment method on load.
                    if (element.getAttribute('checked')) {
                        var event_1 = new CustomEvent('change', {
                            detail: {
                                initial: true,
                            }
                        });
                        element.dispatchEvent(event_1);
                        window._novti_dpm_initialLoad = false;
                        if (((_a = _this.data.frequencyamounts) === null || _a === void 0 ? void 0 : _a.frequency) && !window._novti_dpm_initialFrequency) {
                            window._novti_dpm_initialFrequency = (_b = _this.data.frequencyamounts) === null || _b === void 0 ? void 0 : _b.frequency;
                        }
                    }
                });
                return "continue";
            }
            this_1.addEventListener(this_1.refs[key], 'change', function (event) {
                _this.eventHandler(event, key);
            });
        };
        var this_1 = this;
        for (var _i = 0, _a = Object.entries(this.refs); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], reference = _b[1];
            _loop_1(key, reference);
        }
        return _super.prototype.attach.call(this, element);
    };
    return DynamicPaymentMethods;
}(FieldComponent));
export default DynamicPaymentMethods;
DynamicPaymentMethods.editForm = function () {
    return FieldComponent.editForm(__spreadArrays(editFormDisplay, editFormData, editFormApi, editFormConditional, editFormLayout));
};
Components.addComponent('dynamicpaymentmethods', DynamicPaymentMethods);
